import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ["exportButton", "loadingIndicator", "errorMessage"]
  static values = {
    exportUrl: String,
    statusUrl: String,
    downloadUrl: String,
    interval: { type: Number, default: 2000 },
    maxAttempts: { type: Number, default: 150 }, // 5 minutes max (150 * 2s)
    // Defaults keep the picking dashboard in French; the Partner Dashboard passes translations.
    startMessage: { type: String, default: "Erreur lors du démarrage de l'export" },
    timeoutMessage: { type: String, default: "Le traitement prend trop de temps. Veuillez réessayer plus tard." },
    networkMessage: { type: String, default: "Une erreur de communication s'est produite." },
    processingMessage: { type: String, default: "Une erreur s'est produite lors du traitement." },
    unavailableMessage: { type: String, default: "Fichier non disponible" }
  }

  connect() {
    this.attempts = 0
    this.polling = false
    this.reportId = null
  }

  disconnect() {
    this.stopPolling()
  }

  async startExport(event) {
    event.preventDefault()
    
    if (this.polling) return

    this.hideError()
    this.showLoading()
    
    try {
      const formData = new FormData(event.target.form || event.target)
      
      const response = await fetch(this.exportUrlValue, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      
      if (data.status === 'created' && data.report_id) {
        this.reportId = data.report_id
        this.startPolling()
      } else {
        throw new Error(data.message || 'Export failed')
      }
    } catch (error) {
      console.error('Export error:', error)
      this.showError(this.startMessageValue)
      this.hideLoading()
    }
  }

  startPolling() {
    if (this.polling || !this.reportId) return

    this.polling = true
    this.attempts = 0
    this.pollerId = setInterval(() => this.checkStatus(), this.intervalValue)
  }

  stopPolling() {
    if (this.pollerId) {
      clearInterval(this.pollerId)
      this.pollerId = null
    }
    this.polling = false
  }

  async checkStatus() {
    if (this.attempts >= this.maxAttemptsValue) {
      this.stopPolling()
      this.showError(this.timeoutMessageValue)
      this.hideLoading()
      return
    }

    this.attempts++

    try {
      const statusUrl = this.statusUrlValue.replace(':report_id', this.reportId)
      const response = await fetch(statusUrl, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) throw new Error("Erreur réseau")

      const data = await response.json()

      if (data.status === "ready") {
        this.handleReadyExport(data)
      } else if (data.status === "error") {
        const errorMessage = data.error_message || this.processingMessageValue
        this.showError(errorMessage)
        this.stopPolling()
        this.hideLoading()
      }
    } catch (error) {
      console.error("Polling error:", error)
      this.showError(this.networkMessageValue)
      this.stopPolling()
      this.hideLoading()
    }
  }

  handleReadyExport(data) {
    this.stopPolling()
    this.hideLoading()
    
    if (data.download_url) {
      // Télécharger automatiquement le fichier
      const downloadUrl = this.downloadUrlValue.replace(':report_id', this.reportId)
      this.downloadFile(downloadUrl, data.filename)
    } else {
      this.showError(this.unavailableMessageValue)
    }
  }

  downloadFile(url, filename) {
    const link = document.createElement('a')
    link.href = url
    link.download = filename || 'export.csv'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  showLoading() {
    this.exportButtonTarget.classList.add('hidden')
    this.loadingIndicatorTarget.classList.remove('hidden')
  }

  hideLoading() {
    this.exportButtonTarget.classList.remove('hidden')
    this.loadingIndicatorTarget.classList.add('hidden')
  }

  showError(message) {
    this.errorMessageTarget.textContent = message
    this.errorMessageTarget.classList.remove('hidden')
  }

  hideError() {
    this.errorMessageTarget.classList.add('hidden')
    this.errorMessageTarget.textContent = ''
  }
} 
